import { Button, Paper } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import VideoFrom from "../../components/form/VideoFrom";
import { useAddComingSoon, useUpdateComingSoon } from "../../utils/mutations";
import { useComingSoonById } from "../../utils/queries";
import useStore from "../../utils/store";

const AddComingSoon = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  

  useEffect(() => {
    if (id && !user?.updateComingSoon) {
      notifications.show({ message: "You don't have permission to edit coming soon items", color: "red" });
      navigate("/coming-soon");
    } else if (!id && !user?.addComingSoon) {
      notifications.show({ message: "You don't have permission to add coming soon items", color: "red" });
      navigate("/coming-soon");
    }
  }, [id, user]);

  const { isPending, mutate } = useAddComingSoon();
  const { isPending: isUpdating, mutate: update } = useUpdateComingSoon();
  const { data, isLoading } = useComingSoonById(params.id);
  

  if (!user?.addComingSoon && !user?.updateComingSoon) {
    return null;
  }

  return (
    <>
      
      <Paper withBorder p="md"
        loading={isLoading}
        title={id ? "Edit Coming Soon" : "Add Coming Soon"}
        style={{
          maxWidth: "600px",
          width: "100%",
          marginInline: "auto",
        }}
      >
        <VideoFrom
          type="Coming Soon"
          onFinish={(values) => {
            if (id) {
              update({ id: id, data: values });
            } else {
              mutate(values);
            }
          }}
          update={data}
          submit={
            <Button
              type="submit"
              loading={isPending || isUpdating}
            >
              {id ? "Update" : "Add"}
            </Button>
          }
        />
      </Paper>
    </>
  );
};

export default AddComingSoon;
